var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.14 61.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a710351e-a2ab-47b4-a5a7-e2e79b22f5f7{fill:#e4ebf8;}.aabcf653-59b9-45d6-8048-7a31c03a7710{fill:#fff;}.a5a4a7ab-ef15-49b3-b89d-cdbc651cf4f9{font-size:20px;font-family:SegoeUI-Semilight, Segoe UI;font-weight:300;}.e2f4cb48-8965-40bf-914f-38d7451bf5bb{fill:#c73ecc;}.f77ad55d-24aa-4294-8113-2e0f85ea4519{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.83px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e21860f9-ae8d-4bf7-abd8-d3e800b350f3",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a710351e-a2ab-47b4-a5a7-e2e79b22f5f7",
    d: "M44.64,53.57a22.62,22.62,0,0,1,0-45.24h106a22.62,22.62,0,1,1,0,45.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aabcf653-59b9-45d6-8048-7a31c03a7710",
    d: "M150.64,9.21a21.74,21.74,0,1,1,0,43.48h-106a21.74,21.74,0,1,1,0-43.48h106m0-1.76h-106a23.5,23.5,0,0,0,0,47h106a23.5,23.5,0,0,0,0-47Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "a5a4a7ab-ef15-49b3-b89d-cdbc651cf4f9",
    transform: "translate(76.14 37.53)"
  }, "Model"), /*#__PURE__*/React.createElement("path", {
    className: "e2f4cb48-8965-40bf-914f-38d7451bf5bb",
    d: "M20.79,60.9A5.9,5.9,0,0,1,15.68,58L1.79,33.9a5.92,5.92,0,0,1,0-5.9L15.68,4A5.9,5.9,0,0,1,20.79,1H48.56a5.93,5.93,0,0,1,5.11,3L67.55,28a5.92,5.92,0,0,1,0,5.9L53.67,58a5.93,5.93,0,0,1-5.11,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aabcf653-59b9-45d6-8048-7a31c03a7710",
    d: "M48.56,2A4.91,4.91,0,0,1,52.8,4.45L66.68,28.5a4.9,4.9,0,0,1,0,4.9L52.8,57.45a4.91,4.91,0,0,1-4.24,2.45H20.79a4.92,4.92,0,0,1-4.25-2.45L2.66,33.4a4.88,4.88,0,0,1,0-4.9l13.88-24A4.92,4.92,0,0,1,20.79,2H48.56m0-2H20.79a6.91,6.91,0,0,0-6,3.45L.92,27.5a6.91,6.91,0,0,0,0,6.9L14.81,58.45a6.89,6.89,0,0,0,6,3.45H48.56a6.88,6.88,0,0,0,6-3.45L68.42,34.4a6.91,6.91,0,0,0,0-6.9l-13.89-24a6.9,6.9,0,0,0-6-3.45Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f77ad55d-24aa-4294-8113-2e0f85ea4519",
    cx: 34.67,
    cy: 31.63,
    rx: 25.12,
    ry: 10.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f77ad55d-24aa-4294-8113-2e0f85ea4519",
    cx: 34.67,
    cy: 31.63,
    rx: 10.22,
    ry: 25.12,
    transform: "translate(-11.17 21.57) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f77ad55d-24aa-4294-8113-2e0f85ea4519",
    cx: 34.67,
    cy: 31.63,
    rx: 25.12,
    ry: 10.22,
    transform: "translate(-10.06 45.84) rotate(-60)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "aabcf653-59b9-45d6-8048-7a31c03a7710",
    cx: 41.44,
    cy: 10.1,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "aabcf653-59b9-45d6-8048-7a31c03a7710",
    cx: 48,
    cy: 36.2,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "aabcf653-59b9-45d6-8048-7a31c03a7710",
    cx: 16.16,
    cy: 24.74,
    r: 2.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "aabcf653-59b9-45d6-8048-7a31c03a7710",
    d: "M38,24.59H31.36a1.29,1.29,0,0,0-1.13.66L26.92,31a1.28,1.28,0,0,0,0,1.31L30.23,38a1.29,1.29,0,0,0,1.13.66H38A1.32,1.32,0,0,0,39.12,38l3.3-5.73a1.28,1.28,0,0,0,0-1.31l-3.3-5.73A1.32,1.32,0,0,0,38,24.59Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivated);
export default __webpack_public_path__ + "static/media/activated.c61d3374.svg";
export { ForwardRef as ReactComponent };